module.exports = __webpack_public_path__ + "static/media/ipu.0a1ebeaa.jpg";